import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { RouterModule, Routes } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { HttpModule } from "@angular/http";
import { PharmacyComponent } from "./pharmacy/pharmacy.component";
import { MycardsComponent } from "./mycards/mycards.component";
import { AgmCoreModule } from "@agm/core";
import { GetcardComponent } from './getcard/getcard.component';
import { SearchComponent } from './search/search.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { AboutUsComponent } from './about-us/about-us.component';
import { PricingComponent } from './pricing/pricing.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AccordianComponent } from './accordian/accordian.component';
import { DownloadComponent } from './download/download.component';
import { HowWorksComponent } from './how-works/how-works.component';
import { HelpComponent } from './help/help.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ProgramDescriptionComponent } from './program-description/program-description.component';
import { DrugsCoveredByTheProgramComponent } from './drugs-covered-by-the-program/drugs-covered-by-the-program.component';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RecaptchaLoaderService,
  RecaptchaModule,
} from 'ng-recaptcha';
const globalSettings: RecaptchaSettings = { siteKey: '6Lcz2AUaAAAAAFmA85iTpCtCuCZCTSqTuFi0sZfq' };
const appRoutes: Routes = [
  { path: "", component: HomeComponent },
  { path: 'RefreshComponent', component: PharmacyComponent }, // Temporary route for refresh
  { path: "Home", component: HomeComponent },
  { path: "Pharmacy", component: PharmacyComponent },
  { path: "Pharmacy/:name", component: PharmacyComponent },
  { path: "MyCards", component: MycardsComponent },  
  { path: 'aboutUs', component: AboutUsComponent},
  { path: 'pricing', component: PricingComponent},
  { path: 'contact', component: ContactUsComponent},
  { path: 'download-mobile-app', component: DownloadComponent},
  { path: 'howItWorks', component: HowWorksComponent},
  { path: 'help', component: HelpComponent},
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'program-description', component: ProgramDescriptionComponent }, 
  { path: 'drugs-covered', component: DrugsCoveredByTheProgramComponent },
  { path: 'terms', redirectTo: "terms-and-conditions" }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutUsComponent,
    PricingComponent,
    ContactUsComponent,
    HeaderComponent,
    FooterComponent,
    PharmacyComponent,
    MycardsComponent,
    GetcardComponent,
    SearchComponent,
    AccordianComponent,
    DownloadComponent,
    HowWorksComponent,
    HelpComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    ProgramDescriptionComponent,
    DrugsCoveredByTheProgramComponent
  ],
  imports: [
    RecaptchaModule,
    RouterModule.forRoot(
      appRoutes

      // { enableTracing: true } // <-- debugging purposes only
    ),
    BrowserModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAuNL17CjdSdiDc3fQ46T6Sy2oB2UPuLB0"
    }),
    SlickCarouselModule
  ],
  providers: [{ provide: RECAPTCHA_SETTINGS, useValue: globalSettings }],
  bootstrap: [AppComponent]
})
export class AppModule {}
